module.exports = __webpack_public_path__ + "assets/home-min.f8576017a8989e49c95a99b402b0a9a1.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/img/MasCorominola/home-min.jpg
 ** module id = 427
 ** module chunks = 0
 **/